// Auto-generated by the set-version.js script.
export const ADMIN_UI_VERSION = '1.0.0';
